/**
 * Het uploadvak bij "Voeg afbeeldingen toe".
 *
 * De previews die de bezoeker ziet zijn leidend: de lijst wordt na elke wijziging
 * teruggeschreven naar het bestandsveld, zodat precies die afbeeldingen meegaan
 * met het formulier. Zonder dat terugschrijven gaan gesleepte bestanden verloren
 * en overschrijft een tweede keer bladeren de eerdere keuze.
 */
class ImageUploader {
	constructor(root, onFileLoaded = null) {
		this.root = root;
		this.dropzone = root.querySelector('.dropzone');
		this.fileList = root.querySelector('.fileList');
		this.loader = root.querySelector('.spinner-border');
		this.fileInput = root.querySelector('input[type="file"]');
		this.onFileLoaded = onFileLoaded;

		this.placeholderText = 'Geen afbeeldingen toegevoegd';
		this.files = [];

		this.initEvents();
	}

	initEvents() {
		this.dropzone.addEventListener('click', () => this.fileInput.click());

		this.dropzone.addEventListener('dragover', (e) => {
			e.preventDefault();
			this.dropzone.classList.add('border-success');
		});

		this.dropzone.addEventListener('dragleave', () => {
			this.dropzone.classList.remove('border-success');
		});

		this.dropzone.addEventListener('drop', (e) => {
			e.preventDefault();
			this.dropzone.classList.remove('border-success');
			this.handleFiles(e.dataTransfer.files);
		});

		this.fileInput.addEventListener('change', (e) => {
			this.handleFiles(e.target.files);
		});
	}

	async handleFiles(files) {
		// Het bestandsveld wordt zo meteen overschreven; eerst een eigen kopie van
		// de lijst maken, anders verdwijnt hij onder het inlezen vandaan.
		const selected = [...files];

		this.removePlaceholder();
		this.loader.classList.remove('d-none');

		for (const file of selected) {
			await this.readFile(file);
		}

		this.syncInput();

		setTimeout(() => {
			this.loader.classList.add('d-none');
		}, 500);
	}

	readFile(file) {
		return new Promise(resolve => {
			const reader = new FileReader();

			reader.onload = (e) => {
				const base64 = e.target.result;

				const id = this.randomId();
				this.files.push({id, file, base64});

				this.addToList(id, file.name, base64);

				if (typeof this.onFileLoaded === 'function') {
					this.onFileLoaded({id, file, base64});
				}

				resolve();
			};

			reader.readAsDataURL(file);
		});
	}

	/**
	 * Zet de getoonde lijst terug in het bestandsveld, zodat het formulier exact
	 * de afbeeldingen meestuurt die de bezoeker voor zich ziet.
	 */
	syncInput() {
		const transfer = new DataTransfer();
		this.files.forEach(({file}) => transfer.items.add(file));
		this.fileInput.files = transfer.files;
	}

	randomId() {
		return 'img-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 9);
	}

	addToList(id, filename, base64) {
		const div = document.createRange().createContextualFragment(`
			<div data-id="${id}" class="uploaded-item">
				<div class="me-2 rounded border border-primary preview">
            		<img src="${base64}">
            	</div>
            	<div class="d-flex align-items-start gap-1 ">
					<button type="button" class="btn btn-sm btn-danger">
						<i class="bi bi-trash-fill"></i>
					</button>
					<div class="mr-auto">${filename}</div>
				</div>
            </div>
        `);


		div.querySelector('button').addEventListener('click', () => this.removeFile(id));

		this.fileList.appendChild(div);
	}

	removeFile(id) {
		this.files = this.files.filter(f => f.id !== id);

		const div = this.fileList.querySelector(`div[data-id="${id}"]`);
		if (div) div.remove();

		this.syncInput();

		if (this.files.length === 0) {
			this.addPlaceholder();
		}
	}

	addPlaceholder() {
		if (this.fileList.querySelector('[data-placeholder]')) {
			return;
		}

		const placeholder = document.createElement('div');
		placeholder.setAttribute('data-placeholder', '');
		placeholder.textContent = this.placeholderText;
		this.fileList.appendChild(placeholder);
	}

	/**
	 * De lege-lijstmelding staat er bij het laden van de pagina als <li> in en
	 * wordt daarna als <div> teruggezet; beide moeten weer weg kunnen.
	 */
	removePlaceholder() {
		this.fileList.querySelectorAll('li, [data-placeholder]').forEach(el => {
			if (el.textContent.includes('Geen afbeeldingen')) {
				el.remove();
			}
		});
	}
}


class Index {
	constructor() {
		document.querySelectorAll('[component="image-uploader"]').forEach(el => {
			new ImageUploader(el, ({file, base64}) => {
				// console.log("Bestand geladen:", file.name);
				// console.log("Base64:", base64);
			});
		});

	}
}

export default new Index();
